import { createRouter, createWebHistory } from 'vue-router'

export const router = createRouter({
  history: createWebHistory(),
  scrollBehavior: (_to, _from, savedPosition) => savedPosition ?? { top: 0 },
  routes: [
    { path: '/', component: () => import('@/pages/HomePage.vue') },
    { path: '/games', component: () => import('@/pages/GamesPage.vue') },
    { path: '/games/:slug', component: () => import('@/pages/GameDetailPage.vue') },
    { path: '/raffles', component: () => import('@/pages/RafflesPage.vue') },
    { path: '/claim-win', component: () => import('@/pages/ClaimWinPage.vue') },
    { path: '/contact', component: () => import('@/pages/ContactPage.vue') },
    { path: '/privacy', component: () => import('@/pages/LegalPage.vue'), props: { page: 'privacy' } },
    { path: '/terms', component: () => import('@/pages/LegalPage.vue'), props: { page: 'terms' } },
    { path: '/responsible-gambling', component: () => import('@/pages/LegalPage.vue'), props: { page: 'responsible' } },
    { path: '/admin', component: () => import('@/pages/admin/AdminPage.vue') },
    { path: '/:pathMatch(.*)*', component: () => import('@/pages/NotFoundPage.vue') },
  ],
})
